/**
 * @generated SignedSource<<360b9c74aaaabcf0cd4804d96dd99e67>>
 * @relayHash 69eb36ba6ceb6a97fd8305ec37b957c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da09511c87ac24333200d3b5a82c15c7e20a0787f96d8a33576e72f993aee854

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useJiraAppChromeQuery$variables = {
  appSwitcherProductAri: string;
  atlassianAccountId: string;
  cloudId: string;
  collabContextRoutingAri?: string | null;
  entityAriUserSideNavSettings: string;
  fetchGlobalShortcutsAvailableProducts: boolean;
  fetchOldEntityRecord: boolean;
  isAnonymous: boolean;
  issueKey: string;
  navPlatMenuDataEntityAri: string;
  navPlatSidebarDataEntityAri: string;
  ownerAri?: string | null;
  projectIdOrKey: string;
  projectKey: string;
  shouldCheckProjectType: boolean;
  shouldCheckProjectTypeForIssue: boolean;
  shouldFetchCSMLiveChatAgent: boolean;
  shouldFetchProjectType: boolean;
  shouldFetchProjectTypeForSettingsAndEA: boolean;
  skipAppSwitcherUnitProfile: boolean;
  skipHelpButtonRelayRead: boolean;
  skipNavPlatSidebarData: boolean;
};
export type useJiraAppChromeQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AppChrome" | "TopNavigation_slotsQuery">;
};
export type useJiraAppChromeQuery = {
  response: useJiraAppChromeQuery$data;
  variables: useJiraAppChromeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appSwitcherProductAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextRoutingAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriUserSideNavSettings"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchGlobalShortcutsAvailableProducts"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchOldEntityRecord"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatMenuDataEntityAri"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatSidebarDataEntityAri"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectType"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectTypeForIssue"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchCSMLiveChatAgent"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectType"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectTypeForSettingsAndEA"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAppSwitcherUnitProfile"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipHelpButtonRelayRead"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipNavPlatSidebarData"
},
v22 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v24 = [
  {
    "concreteType": "SettingsMenuItem",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "menuId"
      },
      {
        "kind": "ScalarField",
        "name": "visible"
      }
    ]
  }
],
v25 = [
  {
    "concreteType": "SettingsDisplayProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v26 = {
  "kind": "ScalarField",
  "name": "id"
},
v27 = [
  {
    "args": (v23/*: any*/),
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": (v24/*: any*/),
    "storageKey": "sidebar(first:100)"
  },
  {
    "args": (v23/*: any*/),
    "concreteType": "SettingsDisplayPropertyConnection",
    "kind": "LinkedField",
    "name": "properties",
    "plural": false,
    "selections": (v25/*: any*/),
    "storageKey": "properties(first:100)"
  },
  (v26/*: any*/)
],
v28 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v29 = [
  {
    "kind": "ScalarField",
    "name": "projectType"
  },
  (v26/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v31 = {
  "kind": "ScalarField",
  "name": "productType"
},
v32 = {
  "kind": "ScalarField",
  "name": "url"
},
v33 = {
  "kind": "ScalarField",
  "name": "message"
},
v34 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "atlassianAccountId"
},
v35 = [
  {
    "args": [
      (v28/*: any*/),
      {
        "kind": "Variable",
        "name": "idOrKey",
        "variableName": "projectIdOrKey"
      }
    ],
    "concreteType": "JiraProject",
    "kind": "LinkedField",
    "name": "jira_projectByIdOrKey",
    "plural": false,
    "selections": (v29/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useJiraAppChromeQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "AppChrome"
      },
      {
        "kind": "FragmentSpread",
        "name": "TopNavigation_slotsQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v21/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v15/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v12/*: any*/),
      (v18/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v20/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v19/*: any*/)
    ],
    "kind": "Operation",
    "name": "useJiraAppChromeQuery",
    "selections": [
      {
        "alias": "navPlatL1MenuData",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatMenuDataEntityAri"
          },
          (v22/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "alias": "navPlatSidebarData",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatSidebarDataEntityAri"
          },
          (v22/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldCheckProjectTypeForIssue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v26/*: any*/)
                    ]
                  },
                  (v26/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldCheckProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "projectKey"
                  }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": (v29/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "skipAppSwitcherUnitProfile",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "productAri",
                "variableName": "appSwitcherProductAri"
              }
            ],
            "kind": "LinkedField",
            "name": "appSwitcher_unitProfile",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "unitName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unitIconUrl"
                  }
                ],
                "type": "AppSwitcherUnitProfile"
              }
            ]
          }
        ]
      },
      {
        "condition": "fetchOldEntityRecord",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "userSideNavSettings",
            "args": [
              {
                "kind": "Variable",
                "name": "entityAri",
                "variableName": "entityAriUserSideNavSettings"
              },
              (v22/*: any*/)
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItemConnection",
                "kind": "LinkedField",
                "name": "sidebar",
                "plural": false,
                "selections": (v24/*: any*/)
              },
              {
                "concreteType": "SettingsDisplayPropertyConnection",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v25/*: any*/)
              },
              (v26/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "fetchGlobalShortcutsAvailableProducts",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v28/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "appSwitcher_availableProductsBySite",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v30/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v31/*: any*/),
                          (v32/*: any*/)
                        ],
                        "type": "AppSwitcherSingleUrlProduct"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v31/*: any*/),
                          {
                            "concreteType": "AppSwitcherProductSite",
                            "kind": "LinkedField",
                            "name": "sites",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "siteId"
                              },
                              (v32/*: any*/)
                            ]
                          }
                        ],
                        "type": "AppSwitcherSiteScopedProduct"
                      }
                    ]
                  }
                ],
                "type": "AppSwitcherAvailableProductsBySite"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v33/*: any*/)
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v34/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              (v26/*: any*/)
            ]
          },
          {
            "condition": "shouldFetchProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v35/*: any*/)
          },
          {
            "condition": "shouldFetchCSMLiveChatAgent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v34/*: any*/),
                  (v28/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "csm_liveChatAgent",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v26/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "liveChatActivity"
                      },
                      {
                        "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                        "kind": "LinkedField",
                        "name": "liveChatActivitiesBySpace",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "activityStatus"
                                  },
                                  (v26/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CustomerServiceLiveChatAgent"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "identifier"
                      },
                      (v33/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          }
                        ]
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "collabContextRoutingAri",
                    "variableName": "collabContextRoutingAri"
                  }
                ],
                "kind": "ScalarField",
                "name": "unseenNotificationCount"
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldFetchProjectTypeForSettingsAndEA",
        "kind": "Condition",
        "passingValue": true,
        "selections": (v35/*: any*/)
      },
      {
        "condition": "skipHelpButtonRelayRead",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "propertyKey",
                    "value": "help_button_ui_state"
                  }
                ],
                "concreteType": "JiraEntityPropertyJSON",
                "kind": "LinkedField",
                "name": "jsonUserProperty",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jsonValue"
                  },
                  (v26/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "da09511c87ac24333200d3b5a82c15c7e20a0787f96d8a33576e72f993aee854",
    "metadata": {},
    "name": "useJiraAppChromeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a38b5087561cfab6e9b834d1fcd671db";

export default node;
